import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CalculatorIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M8.33333 18.3332H11.6667C15.8333 18.3332 17.5 16.6665 17.5 12.4998V7.49984C17.5 3.33317 15.8333 1.6665 11.6667 1.6665H8.33333C4.16667 1.6665 2.5 3.33317 2.5 7.49984V12.4998C2.5 16.6665 4.16667 18.3332 8.33333 18.3332Z"
        stroke="#292D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 6.31689V7.15023C13.75 7.83356 13.1917 8.40023 12.5 8.40023H7.5C6.81667 8.40023 6.25 7.84189 6.25 7.15023V6.31689C6.25 5.63356 6.80833 5.06689 7.5 5.06689H12.5C13.1917 5.06689 13.75 5.62523 13.75 6.31689Z"
        stroke="#292D32"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.7801 11.6667H6.78973" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.99592 11.6667H10.0055"
        stroke="#292D32"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.212 11.6667H13.2216" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.7801 14.5832H6.78973" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M9.99592 14.5832H10.0055"
        stroke="#292D32"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.212 14.5832H13.2216" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export default CalculatorIcon;
